export const getCombinedClassName = (baseClassName: string, passedClassName: string | undefined): string =>
    `${baseClassName} ${passedClassName || ''}`.trim();
